<template>
  <Layout>
    <b-tabs
        content-class="tab-content-zone text-muted" nav-class="nav-tabs-custom"
        :class="{'nav-justified':$store.state.layout.browserMode === 'mobile'}">

      <template v-for="(tab, i) in tabs">
        <b-tab :key="`tab-${i}`" :active="i === 0">

          <template v-slot:title>
            <span class="d-inline-block d-sm-none"><i :class="`mdi ${tab.icon}`" /></span>
            <span class="d-none d-sm-inline-block">
                <i :class="`mdi ${tab.icon} icon-padding-right`" />
            </span>
            <span class="d-none d-sm-inline-block">{{ tab.title }}</span>
          </template>

          <keep-alive>
            <component :is="tab.component" />
          </keep-alive>

        </b-tab>
      </template>

    </b-tabs>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main';
import ManageFee from "@/views/pages/manage/manageFee.vue";
import ManageBatch from "./manageBatch.vue";
import Notice from "@/views/pages/manage/Notice.vue";
import ManageUser from "./manageUser.vue";

export default {
  components: { Layout, ManageFee, ManageBatch, Notice, ManageUser, },
  data() {
    return {
      tabs: [
        { title: '충전 요금 관리', icon: 'mdi-table-cog', component: 'ManageFee' },
        { title: 'Batch 관리', icon: 'mdi-cogs', component: 'ManageBatch' },
        { title: '공지사항', icon: 'mdi-bullhorn-outline', component: 'Notice' },
        { title: '사용자 권한 관리', icon: 'mdi-account-cog-outline', component: 'ManageUser' },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .page-content {
    padding-bottom: 0;
  }
}
</style>
